import { useIntl, defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';

const messages = defineMessages({
  loading: {
    description: 'best way to ship loading',
    defaultMessage: 'Loading...',
    id: 'V+DpqY',
  },
  rateError: {
    description: 'best way to ship rate error',
    defaultMessage: 'No rate returned',
    id: '3V1g1A',
  },
  days: {
    description: 'estimatedDeliveryTimeService.days',
    defaultMessage: '{numberOfDays, plural, one {# day} other {# days}}',
    id: 'YuVf8u',
  },
});

const useNormalizeEstimatedDeliveryTime = (estimatedDeliveryTime) => {
  const intl = useIntl();
  if (!estimatedDeliveryTime) {
    return '';
  }
  const estimatedDeliveryTimeAsANumber = Number.parseFloat(estimatedDeliveryTime);
  if (estimatedDeliveryTime === `${estimatedDeliveryTimeAsANumber}`) {
    return intl.formatMessage(messages.days, {
      numberOfDays: estimatedDeliveryTimeAsANumber,
    });
  }
  return estimatedDeliveryTime;
};

export const useCheapestRateDisplayInformation = (bestWayToShip) => {
  const intl = useIntl();
  const services = useSelector(Global.selectSellerServices);
  const { isLoading, hasError, cheapestOption } = bestWayToShip || {};
  const { shippingServiceId, rateError, rate, estimatedDeliveryTime } = cheapestOption || {};
  const fullService = services.find((service) => service.serviceId === `${shippingServiceId}`) || {};
  const serviceName = fullService.name;
  const normalizedEstimatedDelivery = useNormalizeEstimatedDeliveryTime(estimatedDeliveryTime);
  const estimatedDeliveryTimeDisplayText = normalizedEstimatedDelivery ? `(${normalizedEstimatedDelivery})` : '';
  const rateDisplayText =
    rate && rate.totalCost && rate.totalCost.value
      ? intl.formatNumber(rate.totalCost.value, {
          style: 'currency',
          currency: rate.totalCost.code,
        })
      : '';
  if (isLoading) {
    return {
      disabled: true,
      displayText: intl.formatMessage(messages.loading),
    };
  }
  if (hasError || rateError || !serviceName) {
    return {
      disabled: true,
      displayText: intl.formatMessage(messages.rateError),
    };
  }
  return {
    disabled: false,
    displayText: `${serviceName} ${rateDisplayText} ${estimatedDeliveryTimeDisplayText}`,
  };
};
